var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-overlay',{staticClass:"text-center",attrs:{"absolute":true}},[_c('v-progress-circular',{attrs:{"indeterminate":""}}),_c('p',[_vm._v(" "+_vm._s(_vm.$t('loading'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }